module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicCondensed-Thin-26733710fb277932fae759d5bd03ccbc.woff2";